import { render, staticRenderFns } from "./class-wrap.vue?vue&type=template&id=41383de0&scoped=true&"
import script from "./class-wrap.vue?vue&type=script&lang=js&"
export * from "./class-wrap.vue?vue&type=script&lang=js&"
import style0 from "./class-wrap.vue?vue&type=style&index=0&id=41383de0&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41383de0",
  null
  
)

export default component.exports